var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-comment"},[_c('div',{staticClass:"comment-header qrw-label-sm bold"},[_c('BaseIcon',{attrs:{"size":"xs","icon":"message-text-square"}}),_vm._v(" "+_vm._s(_vm.$t("comment.title"))+" ")],1),_c('div',{staticClass:"qrw-paragraph-md"},[_vm._v(" "+_vm._s(_vm.comment)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }